var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInoxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 25,
    viewBox: "0 0 80 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M0 23.1709V1.4082H6.90099V23.1709H0Z",
    fill: "#234B9E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M10.7351 23.1709V1.4082H17.1249L24.4092 13.0578V1.4082H31.0545V23.1709H24.537L17.3805 11.7776V23.1709H10.7351Z",
    fill: "#234B9E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_3",
    d: "M65.5592 23.1709H57.636L65.048 11.7776L58.4027 1.4082H66.1982L69.0098 6.91294L72.0768 1.4082H79.8724L72.8437 11.7776L80.0002 23.1709H72.2047L68.8819 17.0264L65.5592 23.1709Z",
    fill: "#234B9E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2746 12.2893C58.2746 19.0742 52.7794 24.5789 46.0063 24.5789C39.2331 24.5789 33.7378 19.0742 33.7378 12.2893C33.7378 5.50449 39.2331 0 46.0063 0C52.7794 0 58.2746 5.50449 58.2746 12.2893ZM51.3736 12.2893C51.3736 9.34496 48.9456 6.91272 46.0063 6.91272C43.067 6.91272 40.6388 9.34496 40.6388 12.2893C40.6388 15.2337 43.067 17.5381 46.0063 17.5381C48.9456 17.5381 51.3736 15.2337 51.3736 12.2893Z",
    fill: "#234B9E"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInoxLogo);
export default __webpack_public_path__ + "static/media/inox-logo.f63c08765c25bea802978b51f344b111.svg";
export { ForwardRef as ReactComponent };